<template>
    <v-flex v-if="document.published" class="blog-card__post-wrapper" xs12>
        <div class="blog-card__chip-wrapper">
            <v-chip :color="document.tag.color" text-color="white">{{ document.tag.tag }}</v-chip>
        </div>
        <v-card ripple hover class="blog-card__card mx-auto" width="320" height="357" :to="document.articleHref">
            <v-img :src="document.thumbnail + '?x=' + Date.now()" aspect-ratio="2">
                <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-layout>
                </template>
            </v-img>
            <v-card-title class="title font-weight-regular justify-space-between">{{ document.title }}</v-card-title>
            <v-card-subtitle>
                <p><i>{{ convertedDate }}</i></p>
            </v-card-subtitle>
            <v-card-text>
                <p class="blog-card__short-description">{{ document.description }}</p>
            </v-card-text>
        </v-card>
    </v-flex>

    <v-flex v-else-if="isAuthenticated" class="blog-card__post-wrapper" xs12>
        <div class="blog-card__chip-wrapper">
            <v-chip color="black" text-color="#fff"><v-icon>mdi-alien</v-icon> Slēpts</v-chip>
            <v-chip :color="document.tag.color" text-color="white">{{ document.tag.tag }}</v-chip>
        </div>
        <v-card ripple hover class="blog-card__card mx-auto" width="320" height="357" :to="document.articleHref">
            <v-img :src="document.thumbnail + '?x=' + Date.now()" aspect-ratio="2">
                <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-layout>
                </template>
            </v-img>
            <v-card-title class="title font-weight-regular justify-space-between">{{ document.title }}</v-card-title>
            <v-card-subtitle>
                <p><i>{{ convertedDate }}</i></p>
            </v-card-subtitle>
            <v-card-text>
                <p class="blog-card__short-description">{{ document.description }}</p>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    import firebase from 'firebase/app'
    export default {
        data(){
            return{
                isAuthenticated: false
            }
        },
        name: 'BlogCard',
        props: {
            document: Object
        },
        methods: {
        },
        computed: {
            convertedDate: function(){
                const fullDate = this.document.createDate.toDate();

                const time = fullDate.toLocaleTimeString("lv", { hour: '2-digit', minute: '2-digit' });
                const date = fullDate.toLocaleDateString("lv", { year: 'numeric', month: 'short', day: 'numeric' } );

                return date + ' ' + time;
            }
        },
        mounted(){
            const that = this;

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    that.isAuthenticated = true;
                } else {
                    that.isAuthenticated = false;
                }
            });
        }
    }
</script>

<style scoped>
    .v-card__title {
        word-break: break-word !important;
        line-height: 26px !important;
    }
    .blog-card__post-wrapper  {
        position: relative;
    }
    .blog-card__post-wrapper .blog-card__chip-wrapper {
        position: absolute;
        z-index: 1;
        right: -10px;
        top: -10px;
    }
    .blog-card__post-wrapper .v-card {
        overflow: hidden;
    }
    .blog-card__short-description {
        margin-top: -10px !important;
        height: 70px;
        overflow: hidden;
    }
    .v-card__text { padding-top: 0 !important; }
</style>